import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import access_ControlActions from "../../Actions/Access_ControlActions";
import access_ControlConstants from "../../Constants/Access_ControlConstants";
import access_ControlStore from "../../Stores/Access_ControlStores";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { language, localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const forgotPassword = (e) => {
    e.preventDefault();
    const forgetPass = {
      Email: email,
      Language: language,
    };
    setGlobalSpinner(true);
    access_ControlActions.forgetPassword(forgetPass);
    // setTimeout(commonUtils.hideModalPopUp("forgotPasswordClose"), 5000);
  };

  useEffect(() => {
    function getForgotPasswordSuccess() {
      const res = access_ControlStore.getForgotPassword();
      if (res) {
        toast.success(localization.emailHasBeenSendSuccessfully);
      }
      setEmail("");
      setGlobalSpinner(false);
    }

    function getForgotPasswordFailure() {
      const res = access_ControlStore.getForgotPassword();
      toast.error(res, { autoClose: false });
      setEmail("");
      setGlobalSpinner(false);
    }

    access_ControlStore.addChangeListener(
      access_ControlConstants.FORGET_PASSWORD_SUCCESS,
      getForgotPasswordSuccess
    );

    access_ControlStore.addChangeListener(
      access_ControlConstants.FORGET_PASSWORD_FAILURE,
      getForgotPasswordFailure
    );

    return () => {
      access_ControlStore.removeChangeListener(
        access_ControlConstants.FORGET_PASSWORD_SUCCESS,
        getForgotPasswordSuccess
      );

      access_ControlStore.removeChangeListener(
        access_ControlConstants.FORGET_PASSWORD_FAILURE,
        getForgotPasswordFailure
      );
    };
  }, [localization]);

  return (
    <div>
      <div
        className="modal fade"
        id="forgotPassword"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="forgotPassword"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="forgotPassword">
                {localization.forgotPasswordField}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="forgotPasswordClose"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form
                id="forgotPassword"
                autoComplete="off"
                onSubmit={forgotPassword}
              >
                <div className="row mb-4">
                  <div className="col">
                    <div className="form-outline">
                      <label className="form-label" htmlFor="forgotPassword">
                        {localization.emailID}/
                        {localization.usernamePlaceholder}
                      </label>
                      <input
                        type="text"
                        id="emailOrUsername"
                        name="emailOrUsername"
                        className="form-control mb-2"
                        placeholder=""
                        required
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
